import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ResolveMultiSelctOptionProps } from '../../types';
import XIcon from 'icons/X.icon';
import { Button } from 'ncoded-component-library';

import './ResolveMultiSelctOption.styles.scss';

function ResolveMultiSelctOption<T>(props: ResolveMultiSelctOptionProps<T>) {
  const { className, label, value, disabled, onDelete } = props;
  const { t } = useTranslation();

  const classes = classNames('resolve-multi-selct-option', className);

  return (
    <div className={classes}>
      {t(label)}
      <Button
        variant="icon"
        icon={XIcon}
        disabled={disabled}
        aria-label="Remove"
        onClick={(ev) => {
          ev.stopPropagation();
          onDelete(value);
        }}
      />
    </div>
  );
}

export default ResolveMultiSelctOption;
